import history from "App/History";
import { Panel } from "rsuite";
import { useTypedDispatch, useTypedSelector } from "App/Store";
import { useEffect } from "react";
import { DEFAULT_API_ERROR } from "core/constants/Defaults";
import { useNotification } from "shared/hooks/useNotification";
import { useParams } from "react-router-dom";
import { hideLoader, showLoader } from "redux/action/loaderAction";
import { updateBrand } from "core/services/Brand";
import AddBrandForm from "components/AddBrandForm";
import { getBrand, resetBrandDetails } from "redux/action/brandDetailsAction";

interface UrlParams {
  brandId: string;
}

export default function EditBrand() {
  const showNotification = useNotification();
  const dispatch = useTypedDispatch();
  const urlParams = useParams<UrlParams>();
  const { brand } = useTypedSelector((state) => state.brand);

  useEffect(() => {
    dispatch(getBrand(urlParams.brandId));
    return () => {
      dispatch(resetBrandDetails());
    };
  }, [dispatch, urlParams.brandId]);

  async function handleUpdateBrand(brandData: any) {
    if (brand?.id) {
      dispatch(showLoader());
      const formData = new FormData();
      formData.append("id", `${brand.id}`);
      Object.entries(brandData).forEach(([key, value]: any) => {
        if (value === undefined) return;
        if (value === null) {
          formData.append(key, "");
          return;
        }
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === "string") {
          formData.append(key, value);
        } else {
          formData.append(key, JSON.stringify(value));
        }
      });
      const res = await updateBrand(formData, brand.id);
      if (res.status) {
        showNotification({
          message: "Brand updated successfully",
          title: "Success",
          type: "success",
        });
        history.push("/store?tab=brands");
      } else {
        showNotification({
          message: res.message || DEFAULT_API_ERROR,
          title: "Error",
          type: "error",
        });
      }
      dispatch(hideLoader());
    }
  }

  return (
    <Panel bordered shaded>
      <AddBrandForm
        onAddBrand={handleUpdateBrand}
        isEditMode={true}
        brand={brand}
      />
    </Panel>
  );
}
